import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import Spinner from "../../../Plateforme/Atoms/Spinner";
import Section from "../../Atoms/Section";
import H1 from "../../Atoms/H1";
import * as api from "../../../api"
import TableAdminData from "../../Components/TableAdminData";
import { publicToString, semicolonSeparatedToCommadSeparated } from "../../Utils/Format";
import CSVExportButton from "../../Components/CSVExportButton";
import EnhancedTable from "../../Components/EnhancedTable";
import AnnuaireAdmin from "./AnnuaireAdmin";

const Profiles = (props) => {

    const [allProfiles, setAllProfiles] = useState(null);
    const [tableData, setTableData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if(props.fullUserLoading) return;
        if(!props.fullUser?.user) navigate("/");
        if(props.fullUser?.user && props.fullUser.user.role !== "admin") navigate("/");
    }, [props.fullUserLoading, props.fullUser, navigate])

    useEffect(() => {
        //get active users
        api.GetAllUsers().then(res => {
            const _activeUsers = res.data;
            setAllProfiles(_activeUsers)
        }
        ).catch(function (error) {
            console.log(error);
        });
    },[]);

    useEffect(() => {
        if(!allProfiles) return;
        
        const _tableData = [];
        _tableData.push([
            "Entreprise",
            "Nom",
            "Prénom",
            "Email",
            "Lien vers le profil",
            "Lien pour éditer le profil",
            "Lien vers le profil HubSpot",
            "Date de dernière connexion",
            "Date de l'inscrption à la plateforme",
            "Email public",
            "Activité (catégorie VIA)",
            "Évenements (programme VIA)",
            "Photo de courverture",
            "Crédit de la photo de couverture",
            "Photo de profil",
            "Crédit de la photo de profil",
            "Poste",
            "Années d'experience",
            "Ville",
            "Pays",
            "Téléphone portable",
            "Téléphone portable public",
            "Téléphone fixe",
            "Téléphone fixe public",
            "Identifiant Twitter",
            "Identifiant Instagram",
            "Lien linkedin",
            "Date de naissance",
            "Date de naissance public",
            "Nationalité",
            "Langues",
            "CV",
            "Présentation FR",
            "Présentation EN",
            "Adhérent",
            "Membre communauté",
            "Date adhésion club Le FRENCH DESIGN",
        ]);

        for(let i = 0; i < allProfiles.length; i++){
            _tableData.push([
                allProfiles[i].company?.hsCompany?.properties?.name,
                allProfiles[i].hsProfile?.properties?.lastname,
                allProfiles[i].hsProfile?.properties?.firstname,
                allProfiles[i].user.email,
                {link : true, value : "https://connectedby.lefrenchdesign.org/profile?id=" + btoa(allProfiles[i].user.email)},
                {link : true, value : "https://connectedby.lefrenchdesign.org/myprofile?id=" + btoa(allProfiles[i].user.email)},
                {link : true, value : "https://app.hubspot.com/contacts/4837156/record/0-1/" + allProfiles[i].user.hubspotID},
                allProfiles[i].user.last_connection_date,
                allProfiles[i].user.createdAt,
                publicToString(allProfiles[i].user.showmail),
                semicolonSeparatedToCommadSeparated(allProfiles[i].hsProfile?.properties?.cat_gories_via),
                semicolonSeparatedToCommadSeparated(allProfiles[i].hsProfile?.properties?.events),
                allProfiles[i].user.cover && {link : true, value : process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + allProfiles[i].user.cover},
                allProfiles[i].user.creditcover,
                allProfiles[i].user.portrait && {link : true, value : process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + allProfiles[i].user.portrait},
                allProfiles[i].user.creditphoto,
                allProfiles[i].hsProfile?.properties?.jobtitle,
                allProfiles[i].hsProfile?.properties?.seniority,
                allProfiles[i].hsProfile?.properties?.city,
                allProfiles[i].hsProfile?.properties?.country,
                allProfiles[i].hsProfile?.properties?.mobilephone,
                publicToString(allProfiles[i].user.showmobilephone),
                allProfiles[i].hsProfile?.properties?.phone,
                publicToString(allProfiles[i].user.showphone),
                allProfiles[i].hsProfile?.properties?.twitterhandle,
                allProfiles[i].hsProfile?.properties?.instagram_account,
                allProfiles[i].hsProfile?.properties?.lien_linkedin,
                allProfiles[i].hsProfile?.properties?.date_of_birth,
                publicToString(allProfiles[i].user.showdate_of_birth),
                allProfiles[i].hsProfile?.properties?.nationalite,
                allProfiles[i].hsProfile?.properties?.langues, // FIXME langues TOUJOURS pas réglé de leur côté.
                allProfiles[i].user.cv && {link : true, value : process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + allProfiles[i].user.cv},
                allProfiles[i].hsProfile?.properties?.presentation_libre_fr,
                allProfiles[i].hsProfile?.properties?.presentation_libre_en,
                semicolonSeparatedToCommadSeparated(allProfiles[i].hsProfile?.properties?.adherent),
                semicolonSeparatedToCommadSeparated(allProfiles[i].hsProfile?.properties?.acheteur),
                allProfiles[i].hsProfile?.properties?.date_adhesion_club_le_french_design,
            ]);
        }

        setTableData(_tableData);

    }, [allProfiles])

    if (props.fullUserLoading || !allProfiles || !tableData){
        return (<>
            <br/><br/><br/>
            <Spinner/>
        </>)
    }

    return (<>
        <Section className="padding flexblock" style={{justifyContent:"space-between"}}>
            <H1>Profils ({allProfiles.length})</H1>
            <CSVExportButton data={tableData} filename="profiles.csv"/>
        </Section>
        <Section>
            <EnhancedTable sortByColumnIndex={1} data={tableData} />
            {/* <TableAdminData sortByColumnIndex={1} data={tableData}/> */}
        </Section>

    </>)
}

export default Profiles;